import getLinks from './getLinks'
import { getContent } from '@ynap/content-state'

const LandingKey = 'myaccount-landing-content'

export default function getLanding(state, props) {
    const { pages = [], locale } = state
    const { userSummary } = props
    const ignoredPages = pages.filter((page) => page.level !== 1).map((page) => page.id)

    return {
        tiles: getLinks(state, props, ignoredPages),
        summary: userSummary,
        content: getContent(state, LandingKey),
        isFetchingContent: state.content[LandingKey]?.loading,
        fetchContentError: state.content[LandingKey]?.error,
        country: locale.country,
        locale,
    }
}
